import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const PageHeader = () => {
  return (
    <div className="bg-white shadow-sm border-b">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center gap-3">
              <img src="/icon.png" alt="ChatGPT Power-Up" className="w-8 h-8" />
              <span className="font-semibold text-gray-900">ChatGPT Power-Up</span>
            </Link>
          </div>
          <Link to="/">
            <Button variant="outline">← Back to Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageHeader; 